import Layout from '@/components/feature/Layout';
import { aboutData } from '@/mocks/codesajan';
import { galleryImages } from '@/mocks/codesajan';

export default function AboutPage() {
  return (
    <Layout>
      {/* Hero header with image background */}
      <div className="relative py-16 md:py-24 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=water%20infrastructure%20workers%20installing%20large%20pipes%20in%20a%20rural%20bolivian%20landscape%2C%20team%20of%20workers%20in%20orange%20safety%20vests%20near%20a%20concrete%20water%20reservoir%2C%20bright%20daylight%2C%20editorial%20documentary%20photography%2C%20warm%20earthy%20tones%2C%20clean%20composition%20with%20negative%20space%20for%20text%20overlay&width=1800&height=600&seq=about-hero-water-infra&orientation=landscape"
            alt="Trabajadores de infraestructura de agua en San Jacinto Norte"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60" />
        </div>
        <div className="relative z-10 w-full px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto text-center">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-accent-300 mb-3">
            Institución
          </span>
          <h1 className="font-heading font-bold text-3xl md:text-5xl text-white mb-4">
            {aboutData.title}
          </h1>
          <p className="text-white/70 text-sm md:text-base max-w-2xl mx-auto">
            {aboutData.subtitle}
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="w-full px-4 sm:px-6 lg:px-8 py-12 md:py-20">
        <div className="max-w-4xl mx-auto">
          <p className="text-foreground-700 text-base md:text-lg leading-relaxed mb-12">
            {aboutData.description}
          </p>

          {/* Values */}
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-8">
            Nuestros Valores
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-16">
            {aboutData.values.map((value) => (
              <div
                key={value.title}
                className="p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70"
              >
                <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center mb-3">
                  <i className={`${value.icon} text-primary-600 text-lg w-5 h-5 flex items-center justify-center`}></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-950 mb-1">
                  {value.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {value.description}
                </p>
              </div>
            ))}
          </div>

          {/* Gallery */}
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-8">
            Nuestro Trabajo
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
            {galleryImages.map((img, i) => (
              <div key={i} className="relative rounded-xl overflow-hidden aspect-[4/3] group">
                <img
                  src={img.src}
                  alt={img.alt}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
                  <span className="text-white text-xs font-medium">{img.caption}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
}